import type { DataMeta, DataSource } from '@/api/types'

import { formatRelativeTime } from './format'
import { useNow } from './hooks'

/** The sources that say what they are and nothing more: no time, since neither is current data. */
const PLAIN_LABELS: Partial<Record<DataSource, string>> = { demo: 'Demo data', not_live: 'Not live yet' }

/**
 * Where the numbers on screen came from. Live data states how current it is;
 * demo data says so plainly, so generated figures are never mistaken for a
 * tenant's own; a section with no real data source yet says "Not live yet".
 */
export function FreshnessBadge({ meta, now }: { meta: DataMeta | null | undefined; now?: Date }) {
  const clock = useNow(60_000, now)
  if (!meta) return null

  const label = PLAIN_LABELS[meta.source]
  if (label) {
    return (
      <span className="ci-freshness" data-source={meta.source} role="note">
        <span className="ci-freshness__dot" aria-hidden="true" />
        {label}
      </span>
    )
  }

  return (
    <span className="ci-freshness" data-source="live" role="note">
      <span className="ci-freshness__dot" aria-hidden="true" />
      Live data
      {meta.lastUpdatedAt ? (
        <span className="ci-freshness__time"> · Last updated {formatRelativeTime(meta.lastUpdatedAt, clock)}</span>
      ) : null}
    </span>
  )
}
